var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "holiday-rank-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: _vm.$t("lang.commonM.k229"), "left-arrow": "" },
          on: { "click-left": _vm.handleBack, "click-right": _vm.handleToRule },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow02.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c("span", { staticClass: "tit-right" }, [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/rules02.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "rank-bg",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
      },
      [
        _vm.prize1.rank
          ? _c("img", { attrs: { src: require("./images/rank-bg.png") } })
          : _c("img", { attrs: { src: require("./images/norank-bg.png") } }),
      ]
    ),
    _c("div", { staticClass: "bg-block" }, [
      _c("div", { staticClass: "holiday-rank-bar" }, [
        _c("div", { staticClass: "prize" }, [
          _c("div", { staticClass: "two" }, [
            _c("img", {
              staticClass: "rank_c2_avatar",
              attrs: { src: _vm._f("imgPath")(_vm.prize2.avatar), alt: "" },
            }),
            _vm._m(0),
            _c("div", { staticClass: "item-num" }, [
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.prize2.nickname || "--")),
              ]),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(_vm.prize2.score || "--") + " "),
                _c("i", [
                  _vm._v("(" + _vm._s(_vm.$t("lang.valRuFe.points")) + ")"),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "prize-gap" }),
          _c("div", { staticClass: "one" }, [
            _c("img", {
              staticClass: "rank_c1_avatar",
              attrs: { src: _vm._f("imgPath")(_vm.prize1.avatar), alt: "" },
            }),
            _vm._m(1),
            _c("div", { staticClass: "item-num" }, [
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.prize1.nickname || "--")),
              ]),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(_vm.prize1.score || "--") + " "),
                _c("i", [
                  _vm._v("(" + _vm._s(_vm.$t("lang.valRuFe.points")) + ")"),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "prize-gap" }),
          _c("div", { staticClass: "three" }, [
            _c("img", {
              staticClass: "rank_c3_avatar",
              attrs: { src: _vm._f("imgPath")(_vm.prize3.avatar), alt: "" },
            }),
            _vm._m(2),
            _c("div", { staticClass: "item-num kiss-num3" }, [
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.prize3.nickname || "--")),
              ]),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(_vm.prize3.score || "--") + " "),
                _c("i", [
                  _vm._v("(" + _vm._s(_vm.$t("lang.valRuFe.points")) + ")"),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "holiday-rank-con" }, [
        _vm._m(3),
        _c(
          "div",
          { staticClass: "rank-body" },
          [
            _vm.ended === false
              ? _c("div", { staticClass: "tit-time" }, [
                  _c("span", { staticClass: "time" }, [
                    _vm._v(_vm._s(_vm.$t("lang.kissGf.ranking"))),
                  ]),
                  _c("span", { staticClass: "time" }, [
                    _vm._v(
                      _vm._s(_vm.actStartTime) + "-" + _vm._s(_vm.actEndTime)
                    ),
                  ]),
                ])
              : _c("div", { staticClass: "time-tips tips-end" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k242"))),
                ]),
            _vm.rankList.length > 0
              ? _vm._l(_vm.rankList, function (item) {
                  return _c("div", { key: item, staticClass: "agent-item" }, [
                    item.rank
                      ? _c("span", { staticClass: "rank-num" }, [
                          _vm._v(_vm._s(item.rank)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "avatar rank-avatar" }, [
                      _c("img", {
                        attrs: { src: _vm._f("imgPath")(item.avatar), alt: "" },
                      }),
                      _c("span", [_vm._v(_vm._s(item.nickname))]),
                    ]),
                    _c("div", { staticClass: "item-num" }, [
                      _vm._v(" " + _vm._s(item.score) + " "),
                      _c("i", [_vm._v(_vm._s(_vm.$t("lang.valRuFe.points")))]),
                    ]),
                  ])
                })
              : _vm._e(),
          ],
          2
        ),
        _vm.owners
          ? _c(
              "div",
              {
                staticClass: "agent-item owner-item",
                style: { "margin-bottom": `${_vm.bottomBarHeight}px` },
              },
              [
                _c("div", { staticClass: "owner-item-content" }, [
                  _c("div", { staticClass: "avatar" }, [
                    _vm.owners.rank
                      ? _c("span", { staticClass: "rank-num" }, [
                          _vm._v(_vm._s(_vm.owners.rank)),
                        ])
                      : _c("span", { staticClass: "rank-num not-in-rank" }, [
                          _vm._v("--"),
                        ]),
                    _c("div", { staticClass: "avatar-box" }, [
                      _c("img", {
                        attrs: {
                          src: _vm._f("imgPath")(_vm.owners.avatar),
                          alt: "",
                        },
                      }),
                      _c("div", { staticClass: "avatar-txt" }, [
                        _c("span", [_vm._v(_vm._s(_vm.owners.nickname))]),
                        !_vm.owners.rank
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("lang.ween.noRanking"))),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "item-num" }, [
                    _vm._v(" " + _vm._s(_vm.owners.score || 0) + " "),
                    _c("i", [_vm._v(_vm._s(_vm.$t("lang.valRuFe.points")))]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/n-two.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/n-one.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-sort" }, [
      _c("img", { attrs: { src: require("./images/n-three.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rank-special-head" }, [
      _c("div", { staticClass: "rank-sty-bg2" }, [
        _c("div", { staticClass: "rank-sty-bg3" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }